<div class="bg-blue-800 text-white text-left px-8 py-16 text-3xl rounded-b-md">
  Commande
</div>
<div class="grid gap-4 w-full p-8">
  <div>
    <button
      mat-raised-button
      class="text-xl py-4 bg-green-500 text-white w-120"
      (click)="showAddModal()"
    >
      <mat-icon>add</mat-icon> Ajouter un commande
    </button>
    <div class="grid mt-10">
      <label>Utilisateur</label>
      <unilog-recherche
        style="width: 235px"
        appearance="outline"
        champsModel="Tiers_code"
        champsAffiche="Tiers_RS"
        [ServerSideFiltering]="true"
        textErreur="Veuillez Entrer un tier valide"
        [showError]="true"
        recherche="API_ListeRep"
        [api]="generalService.api"
        placeholder="Nom"
        [(ngModel)]="searchUser"
        (ChampEnter)="searchCmdsByUsers()"
      >
      </unilog-recherche>
    </div>
  </div>
  <div class="shadow overflow-hidden rounded border-b border-gray-200">
    <table class="w-full bg-white">
      <thead class="bg-gray-800 text-white">
        <tr>
          <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            Numero de commande
          </th>
          <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            Tier Code
          </th>
          <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            Tier Rs
          </th>
          <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            Date
          </th>
        </tr>
      </thead>
      <tbody class="text-gray-700">
        <tr
          (click)="openDetail(detail.Doc_Num)"
          *ngFor="let detail of data; index as i"
          [class]="i % 2 == 0 ? 'bg-gray-100' : ''"
        >
          <td class="text-left py-3 px-16">{{ detail.Doc_Num }}</td>
          <td class="text-left py-3 px-16">{{ detail.Tiers_code }}</td>
          <td class="text-left py-3 px-16">{{ detail.Tiers_RS }}</td>
          <td class="text-left py-3 px-16">
            {{ detail.Doc_Date | date: "dd-MM-YYYY" }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<ng-template #addCommand>
  <unilog-recherche
    appearance="outline"
    champsModel="Tiers_code"
    champsAffiche="Tiers_RS"
    [ServerSideFiltering]="true"
    textErreur="Veuillez Entrer un tier valide"
    [showError]="true"
    recherche="API_ListeRep"
    [api]="generalService.api"
    placeholder="Nom"
    [(ngModel)]="searchUser"
    (ChampEnter)="searchCmdsByUsers()"
  >
  </unilog-recherche>
  <label>Client</label>
  <unilog-recherche
    appearance="outline"
    champsModel="Tiers_code"
    champsAffiche="Tiers_RS"
    [ServerSideFiltering]="true"
    textErreur="Veuillez Entrer un tier valide"
    [showError]="true"
    recherche="Tier"
    [api]="generalService.api"
    placeholder="Client"
    [(ngModel)]="client"
    (ChampEnter)="ChampEnter()"
  >
  </unilog-recherche>
  <div *ngIf="clientData">
    <span class="text-2xl text-blue-800 font-bold py-4">{{
      clientData.Tiers_RS
    }}</span>
    <div class="grid grid-cols-2">
      <div class="flex">
        <label>Adresse :</label>
        <div>{{ clientData.Tiers_Adresse }}</div>
      </div>
      <div class="flex">
        <label>ville :</label>
        <div>{{ clientData.Tiers_Ville }}</div>
      </div>
      <div class="flex">
        <label>Pays :</label>
        <div>{{ clientData.Tiers_Pays }}</div>
      </div>
      <div class="flex">
        <label>Famille 1 :</label>
        <div>{{ clientData.Tiers_Famille }}</div>
      </div>

      <div class="flex">
        <label>civilité :</label>
        <div>{{ clientData.Tiers_Civilite }}</div>
      </div>
    </div>
  </div>
  <hr class="my-8" />
  <div class="w-full">
    <mat-form-field appearance="outline">
      <label>lieu de livraison</label>

      <mat-select matNativeControl required [(ngModel)]="API_RapportVisiteD">
        <mat-option
          *ngFor="let ville of generalService.listeVille"
          [value]="ville"
          >{{ ville }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </div>
  <hr class="my-8" />
  <div class="flex gap-4 items-center">
    <div class="w-3/4">
      <label>Article</label>
      <unilog-recherche
        appearance="outline"
        textErreur="Veuillez Entrer un tier valide"
        [showError]="true"
        placeholder="Article"
        recherche="article"
        [api]="generalService.api"
        champsAffiche="Art_Code"
        champsModel="Art_Code"
        [ServerSideFiltering]="true"
        placeholder="article"
        [(ngModel)]="article"
      >
      </unilog-recherche>
    </div>
    <!-- <span class="text-green-600 ml-2" *ngIf="false">Disponible</span>
    <span class="text-red-600 ml-2">Non disponible</span> -->
    <div class="w-1/6">
      <label>Quantité</label>
      <mat-form-field class="w-full" appearance="outline">
        <input
          type="number"
          matInput
          placeholder="Quantité "
          [(ngModel)]="qte"
        />
      </mat-form-field>
    </div>
    <button
      (click)="addNewCommand()"
      class="bg-green-500 text-white px-20"
      style="height: 52px"
      mat-flat-button
    >
      Ajouter
    </button>
  </div>
  <div class="flex flex-col mb-10" *ngIf="listCommandAjout.length > 0">
    <div class="flex bg-gray-700 text-white justify-between p-8">
      <div class="w-1/6">Code article</div>
      <div class="w-1/3">Désigniation</div>
      <div class="w-1/6">Prix unitaire Brut</div>
      <div class="w-1/6">TVA</div>
      <div class="w-1/6">THT</div>
      <div class="w-1/6">TTC</div>
      <div class="w-1/3">Quantité</div>
    </div>
    <div class="flex flex-col border">
      <div
        *ngFor="let row of listCommandAjout; index as i"
        class="flex justify-between p-8 border-b"
      >
        <div class="w-1/6">{{ row.Art_Code }}</div>
        <div class="w-1/3">{{ row.Art_Des }}</div>
        <div class="w-1/6">{{ row.Art_PV }}</div>
        <div class="w-1/6">{{ row.Art_TVA }}</div>
        <div class="w-1/6">{{ row.Art_PV * row.quantite }}</div>
        <div class="w-1/6">
          {{ (row.Art_PV * row.quantite * row.Art_TVA) / 100 }}
        </div>
        <div class="w-1/3 flex justify-center items-center">
          <div
            (click)="
              row.quantite == 1
                ? removeCommand(i)
                : (row.quantite = row.quantite - 1)
            "
            class="cursor-pointer text-2xl w-30 h-30 flex justify-center items-center m-1 font-medium py-4 px-8 rounded-full text-white bg-red-700 border border-red-700"
          >
            <div
              class="text-base font-normal leading-none max-w-full flex-initial"
            >
              -
            </div>
          </div>
          {{ row.quantite }}
          <div
            (click)="row.quantite = row.quantite + 1"
            class="cursor-pointer text-2xl w-30 h-30 flex justify-center items-center m-1 font-medium py-4 px-8 rounded-full text-white bg-green-500 border border-green-500"
          >
            <div
              class="text-base font-normal leading-none max-w-full flex-initial"
            >
              +
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex justify-center">
    <button
      mat-raised-button
      class="w-full text-2xl py-4"
      color="primary"
      (click)="logClient()"
    >
      Lancer le commande
    </button>
  </div>
</ng-template>

<ng-template #details>
  <div style="width: 75vw; height: 70vh">
    <div class="flex flex-col mb-10" *ngIf="detailsData.length > 0">
      <div class="flex bg-gray-700 text-white justify-between p-8">
        <div class="w-1/3">Désigniation</div>
        <div class="w-1/6">Date</div>
        <div class="w-1/6">PHTB</div>
        <div class="w-1/6">PUHTB</div>
        <div class="w-1/6">PUHTN</div>
        <div class="w-1/6">Quantité</div>
        <div class="w-1/6">THT</div>
      </div>
      <div class="flex flex-col border">
        <div
          *ngFor="let row of detailsData; index as i"
          class="flex justify-between p-8 border-b"
        >
          <div class="w-1/3">{{ row.Art_Des }}</div>
          <div class="w-1/6">{{ row.DocD_Date | date: "dd-MM-YYYY" }}</div>
          <div class="w-1/6">{{ row.DocD_PHTB }}</div>
          <div class="w-1/6">{{ row.DocD_PUHTB }}</div>
          <div class="w-1/6">{{ row.DocD_PUHTN }}</div>
          <div class="w-1/6">{{ row.DocD_Q }}</div>
          <div class="w-1/6">{{ row.DocD_THT }}</div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
